import {
  ADD_ROLE_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_USER_FAILURE,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  GET_ROLES_FAIL,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  HOTEL_UPDATE_FAIL,
  HOTEL_UPDATE_REQUEST,
  HOTEL_UPDATE_SUCCESS,
  MONTHLY_COMMISSION_FAIL,
  MONTHLY_COMMISSION_REQUEST,
  MONTHLY_COMMISSION_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  ROLE_USER_DELETE_FAIL,
  ROLE_USER_DELETE_REQUEST,
  ROLE_USER_DELETE_SUCCESS,
  ROLE_USER_GET_ALL_FAIL,
  ROLE_USER_GET_ALL_REQUEST,
  ROLE_USER_GET_ALL_SUCCESS,
  ROLE_USER_UPDATE_FAIL,
  ROLE_USER_UPDATE_REQUEST,
  ROLE_USER_UPDATE_SUCCESS,
  SHIFT_MONTHLY_COMMISSION_FAILURE,
  SHIFT_MONTHLY_COMMISSION_REQUEST,
  SHIFT_MONTHLY_COMMISSION_SUCCESS,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  USER_DELETE_FAIL,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_IMPERSONATE_REQUEST,
  USER_IMPERSONATE_SUCCESS,
  USER_IMPERSONATE_FAIL,
  GET_SINGLE_USER_REQUEST,
  GET_SINGLE_USER_SUCCESS,
  GET_SINGLE_USER_FAIL,
  USER_VERIFY_OTP_REQUEST,
  USER_VERIFY_OTP_SUCCESS,
  USER_VERIFY_OTP_FAIL,
  USER_RESEND_OTP_REQUEST,
  USER_RESEND_OTP_SUCCESS,
  USER_RESEND_OTP_FAIL,
  MFA_SETTING_TOGGLE_REQUEST,
  MFA_SETTING_TOGGLE_SUCCESS,
  MFA_SETTING_TOGGLE_FAILURE,
  USER_SETTINGS_UPDATE_SUCCESS,
  USER_SETTINGS_UPDATE_REQUEST,
  USER_SETTINGS_UPDATE_FAIL,
} from "../Constants/userconstants";
import api, { unwrapData } from "../service/api";

const getMessage = (error, fallback = "Request failed") =>
  error?.response?.data?.message || error?.response?.data?.error || error.message || fallback;

export const userRegister = (payload) => async (dispatch) => {
  try {
    dispatch({ type: USER_REGISTER_REQUEST });
    const { data } = await api.post("api/users/register", payload);
    dispatch({ type: USER_REGISTER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: USER_REGISTER_FAIL, payload: getMessage(error) });
  }
};

export const userLogin =
  ({ email, password, deviceId }) =>
  async (dispatch) => {
    try {
      dispatch({ type: USER_LOGIN_REQUEST });
      const { data } = await api.post("api/users/login", {
        email,
        password,
        deviceId,
      });

      if (data?.mfaRequired) {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: {
            userId: data.userId,
            isRoleUser: data.isRoleUser,
            mfaRequired: true,
          },
        });
      } else {
        dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
        localStorage.setItem("userInfo", JSON.stringify(data));
      }
    } catch (error) {
      dispatch({ type: USER_LOGIN_FAIL, payload: getMessage(error) });
    }
  };

export const verifyOTP =
  (userId, otp, isRoleUser, rememberDevice, deviceId) => async (dispatch) => {
    try {
      dispatch({ type: USER_VERIFY_OTP_REQUEST });
      const { data } = await api.post("api/users/verify-otp", {
        userId,
        otp,
        isRoleUser,
        rememberDevice,
        deviceId,
      });
      dispatch({ type: USER_VERIFY_OTP_SUCCESS, payload: data });
      localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error) {
      dispatch({ type: USER_VERIFY_OTP_FAIL, payload: getMessage(error) });
    }
  };

export const resendOTP = (userId, isRoleUser) => async (dispatch) => {
  try {
    dispatch({ type: USER_RESEND_OTP_REQUEST });
    const { data } = await api.post("api/users/resend-otp", {
      userId,
      isRoleUser,
    });
    dispatch({ type: USER_RESEND_OTP_SUCCESS, payload: data.message });
  } catch (error) {
    dispatch({ type: USER_RESEND_OTP_FAIL, payload: getMessage(error) });
  }
};

export const impersonateUser =
  (id, email, navigate) => async (dispatch) => {
    try {
      dispatch({ type: USER_IMPERSONATE_REQUEST });

      const { data } = await api.post("api/users/impersonate", { id, email });
      dispatch({ type: USER_IMPERSONATE_SUCCESS, payload: data });
      localStorage.setItem("userInfo", JSON.stringify(data));

      if (data) {
        const redirectPath =
          data.isSuperAdmin === true || data.isPartner === true
            ? "/super-admin"
            : data.isAdmin === true && data.isAdminX === false
            ? "/dashboard"
            : data.isAdminX === true && data.isAdmin === true
            ? "/dashboard/adminx"
            : data.isRoleUser === true
            ? "/dashboard"
            : "/";
        navigate(redirectPath);
      }
    } catch (error) {
      dispatch({ type: USER_IMPERSONATE_FAIL, payload: getMessage(error) });
    }
  };

export const impersonateUserEnd =
  (id, email, navigate) => async (dispatch) => {
    try {
      dispatch({ type: USER_IMPERSONATE_REQUEST });
      const { data } = await api.post("api/users/impersonateEnd", { id, email });
      dispatch({ type: USER_IMPERSONATE_SUCCESS, payload: data });
      localStorage.setItem("userInfo", JSON.stringify(data));

      if (data) {
        const redirectPath =
          data.isSuperAdmin === true || data.isPartner === true
            ? "/super-admin"
            : data.isAdmin === true && data.isAdminX === false
            ? "/dashboard"
            : data.isAdminX === true && data.isAdmin === true
            ? "/dashboard/adminx"
            : data.isRoleUser === true
            ? "/dashboard"
            : "/";
        navigate(redirectPath);
      }
    } catch (error) {
      dispatch({ type: USER_IMPERSONATE_FAIL, payload: getMessage(error) });
    }
  };

export const userLogout = () => (dispatch) => {
  dispatch({ type: USER_LOGOUT });
  localStorage.removeItem("userInfo");
};

export const listUsers = () => async (dispatch) => {
  try {
    dispatch({ type: USER_LIST_REQUEST });
    const { data } = await api.get("api/users");
    dispatch({
      type: USER_LIST_SUCCESS,
      payload: unwrapData(data, "users"),
    });
  } catch (error) {
    dispatch({ type: USER_LIST_FAIL, payload: getMessage(error) });
  }
};

export const getSingleUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_USER_REQUEST });
    const { data } = await api.get(`api/users/client/${id}`);
    dispatch({
      type: GET_SINGLE_USER_SUCCESS,
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: GET_SINGLE_USER_FAIL,
      payload: getMessage(error),
    });
  }
};

export const getUserDetails = () => async (dispatch) => {
  try {
    dispatch({ type: USER_DETAILS_REQUEST });
    const { data } = await api.get("api/users/profile");
    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data.user || data,
    });
  } catch (error) {
    const message = getMessage(error);
    dispatch({
      type: USER_DETAILS_FAIL,
      payload: message,
    });
  }
};

export const deleteUser = (userId) => async (dispatch) => {
  try {
    dispatch({ type: USER_DELETE_REQUEST });
    await api.delete(`api/users/${userId}`);
    dispatch({ type: USER_DELETE_SUCCESS, payload: { _id: userId } });
  } catch (error) {
    dispatch({ type: USER_DELETE_FAIL, payload: getMessage(error) });
  }
};

export const getRoles = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ROLES_REQUEST });
    const { data } = await api.get("api/users/role");
    dispatch({ type: GET_ROLES_SUCCESS, payload: unwrapData(data, "roles") });
  } catch (error) {
    dispatch({ type: GET_ROLES_FAIL, payload: getMessage(error) });
  }
};

export const addRole = (roleData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_ROLE_REQUEST });
    const response = await api.post("api/users/role", roleData);
    dispatch({ type: ADD_ROLE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: ADD_ROLE_FAILURE, payload: getMessage(error) });
  }
};

export const deleteRole = (roleId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ROLE_REQUEST });
    await api.delete("api/users/role", {
      data: { roleId },
    });
    dispatch({ type: DELETE_ROLE_SUCCESS, payload: { _id: roleId } });
  } catch (error) {
    dispatch({ type: DELETE_ROLE_FAIL, payload: getMessage(error) });
  }
};

export const addUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_USER_REQUEST });
    const { data } = await api.post("api/users/addUser", userData);
    dispatch({ type: ADD_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: ADD_USER_FAILURE, payload: getMessage(error) });
  }
};

export const getRoleUsers = () => async (dispatch) => {
  try {
    dispatch({ type: ROLE_USER_GET_ALL_REQUEST });
    const { data } = await api.get("api/users/roleUsers");
    dispatch({
      type: ROLE_USER_GET_ALL_SUCCESS,
      payload: unwrapData(data, "users", "roleUsers"),
    });
  } catch (error) {
    dispatch({ type: ROLE_USER_GET_ALL_FAIL, payload: getMessage(error) });
  }
};

export const updateUserProfile = (user) => async (dispatch) => {
  try {
    dispatch({ type: USER_UPDATE_PROFILE_REQUEST });
    const { data } = await api.post("api/users/profile", user);
    dispatch({ type: USER_UPDATE_PROFILE_SUCCESS });
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: USER_UPDATE_PROFILE_FAIL,
      payload: getMessage(error),
    });
  }
};

export const updateHotel = (updatedHotel) => async (dispatch) => {
  try {
    dispatch({ type: HOTEL_UPDATE_REQUEST });
    const { data } = await api.put("api/users/changeDetails", updatedHotel);
    dispatch({ type: HOTEL_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: HOTEL_UPDATE_FAIL, payload: getMessage(error) });
  }
};

export const updateUserSettings = (payload) => async (dispatch) => {
  try {
    dispatch({ type: USER_SETTINGS_UPDATE_REQUEST });
    const { data } = await api.put("api/users/settings", payload);
    dispatch({
      type: USER_SETTINGS_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: USER_SETTINGS_UPDATE_FAIL,
      payload: getMessage(error, "Settings update failed"),
    });
  }
};

export const deleteRoleUser = (userId) => async (dispatch) => {
  try {
    dispatch({ type: ROLE_USER_DELETE_REQUEST });
    await api.delete(`api/users/roleUsers/${userId}`);
    dispatch({ type: ROLE_USER_DELETE_SUCCESS, payload: { _id: userId } });
  } catch (error) {
    dispatch({ type: ROLE_USER_DELETE_FAIL, payload: getMessage(error) });
  }
};

export const updateRole = (roleId, updatedRoleData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ROLE_REQUEST });
    const { data } = await api.put(`api/users/role/${roleId}`, updatedRoleData);
    dispatch({
      type: UPDATE_ROLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_ROLE_FAIL,
      payload: getMessage(error),
    });
  }
};

export const updateRoleUser = (userId, userData) => async (dispatch) => {
  try {
    dispatch({ type: ROLE_USER_UPDATE_REQUEST });
    const { data } = await api.put(`api/users/roleUsers/${userId}`, userData);
    dispatch({ type: ROLE_USER_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ROLE_USER_UPDATE_FAIL,
      payload: getMessage(error),
    });
  }
};

export const getMonthlyCommission = (userId) => async (dispatch) => {
  try {
    dispatch({ type: MONTHLY_COMMISSION_REQUEST });
    const { data } = await api.get(`api/users/monthlyCommission/${userId}`);
    dispatch({ type: MONTHLY_COMMISSION_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MONTHLY_COMMISSION_FAIL, payload: getMessage(error) });
  }
};

export const shiftMonthlyCommission =
  (partnerId, monthNumber) => async (dispatch) => {
    try {
      dispatch({ type: SHIFT_MONTHLY_COMMISSION_REQUEST });
      await api.post("api/users/commission-shift", {
        partnerId,
        monthNumber,
      });
      dispatch({ type: SHIFT_MONTHLY_COMMISSION_SUCCESS });
    } catch (error) {
      dispatch({
        type: SHIFT_MONTHLY_COMMISSION_FAILURE,
        payload: getMessage(error),
      });
    }
  };

export const resetPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    const { data } = await api.post("api/users/reset-password", { email });
    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: RESET_PASSWORD_FAILURE,
      payload: getMessage(error),
    });
  }
};

export const mfaSettingToggle = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MFA_SETTING_TOGGLE_REQUEST });
    const { data } = await api.patch("api/users/mfa-toggle", {
      ...payload,
    });

    dispatch({
      type: MFA_SETTING_TOGGLE_SUCCESS,
      payload: data.message,
    });

    return data;
  } catch (error) {
    dispatch({
      type: MFA_SETTING_TOGGLE_FAILURE,
      payload: getMessage(error),
    });

    throw error;
  }
};
